// extracted by mini-css-extract-plugin
export var standaloneTable = "_fi-0";
export var withExtraHeader = "_fi-1";